/* eslint-disable react/no-danger, react/no-unescaped-entities, max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'gatsby-plugin-react-intl';

import { intlShape } from '@prospectus/common/types/intlShape';
import { appendProgramToProgramType } from '@utils/edxProductDisplay';
import { ListStyles, formatList } from '@utils/formatting';

function ProgramDataBarDetails({
  title,
  type,
  owners,
  intl,
}) {
  const partnerList = formatList(
    owners.map((owner) => owner.key),
    ListStyles.conjunction,
    intl,
  );

  return (
    <div className="program">
      <div className="type">
        <FormattedMessage
          id="prospectus.programDataBarDetails.programTypeAndTitle"
          defaultMessage="{programType} in {programTitle}"
          description="This text is on the button that when clicked, expands a description of the course or program"
          values={{
            programType: appendProgramToProgramType(type),
            programTitle: <div className="title">{title}</div>,
          }}
        />
      </div>
      <div className="institution">{partnerList}</div>
    </div>
  );
}

ProgramDataBarDetails.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  owners: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      key: PropTypes.string,
      logoImageUrl: PropTypes.string,
    }),
  ).isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(ProgramDataBarDetails);
